/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ChatMessageData,
    EnterRoomParam,
    GetSessionsResponse,
    GetSessionsResponseItem,
    NotificationSettingParam,
    NotificationSettingsData,
    SendChatMessage,
} from '../models';

export interface ChatControllerEnterRoomRequest {
    enterRoomParam: EnterRoomParam;
}

export interface ChatControllerGetMessagesRequest {
    cursor?: number;
    limit?: number;
    toUserId?: string;
    latestMessageId?: number;
}

export interface ChatControllerGetSessionRequest {
    targetUserId: string;
}

export interface ChatControllerGetSessionsRequest {
    cursor?: number;
    limit?: number;
}

export interface ChatControllerSendMessageRequest {
    sendChatMessage: SendChatMessage;
}

export interface ChatControllerSetNotificationRequest {
    notificationSettingParam: NotificationSettingParam;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Enter room
     */
    async chatControllerEnterRoomRaw(requestParameters: ChatControllerEnterRoomRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.enterRoomParam === null || requestParameters.enterRoomParam === undefined) {
            throw new runtime.RequiredError('enterRoomParam','Required parameter requestParameters.enterRoomParam was null or undefined when calling chatControllerEnterRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/enterRoom`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.enterRoomParam,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Enter room
     */
    async chatControllerEnterRoom(requestParameters: ChatControllerEnterRoomRequest): Promise<string> {
        const response = await this.chatControllerEnterRoomRaw(requestParameters);
        return await response.value();
    }

    /**
     * get chat message list
     */
    async chatControllerGetMessagesRaw(requestParameters: ChatControllerGetMessagesRequest): Promise<runtime.ApiResponse<Array<ChatMessageData>>> {
        const queryParameters: any = {};

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.toUserId !== undefined) {
            queryParameters['toUserId'] = requestParameters.toUserId;
        }

        if (requestParameters.latestMessageId !== undefined) {
            queryParameters['latestMessageId'] = requestParameters.latestMessageId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/messages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * get chat message list
     */
    async chatControllerGetMessages(requestParameters: ChatControllerGetMessagesRequest): Promise<Array<ChatMessageData>> {
        const response = await this.chatControllerGetMessagesRaw(requestParameters);
        return await response.value();
    }

    /**
     * get my session
     */
    async chatControllerGetSessionRaw(requestParameters: ChatControllerGetSessionRequest): Promise<runtime.ApiResponse<GetSessionsResponseItem>> {
        if (requestParameters.targetUserId === null || requestParameters.targetUserId === undefined) {
            throw new runtime.RequiredError('targetUserId','Required parameter requestParameters.targetUserId was null or undefined when calling chatControllerGetSession.');
        }

        const queryParameters: any = {};

        if (requestParameters.targetUserId !== undefined) {
            queryParameters['targetUserId'] = requestParameters.targetUserId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/session`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * get my session
     */
    async chatControllerGetSession(requestParameters: ChatControllerGetSessionRequest): Promise<GetSessionsResponseItem> {
        const response = await this.chatControllerGetSessionRaw(requestParameters);
        return await response.value();
    }

    /**
     * get my session list 
     */
    async chatControllerGetSessionsRaw(requestParameters: ChatControllerGetSessionsRequest): Promise<runtime.ApiResponse<GetSessionsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/sessions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * get my session list 
     */
    async chatControllerGetSessions(requestParameters: ChatControllerGetSessionsRequest): Promise<GetSessionsResponse> {
        const response = await this.chatControllerGetSessionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Leave room
     */
    async chatControllerLeaveRoomRaw(): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/leaveRoom`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Leave room
     */
    async chatControllerLeaveRoom(): Promise<string> {
        const response = await this.chatControllerLeaveRoomRaw();
        return await response.value();
    }

    /**
     * get user notification setting
     */
    async chatControllerNotificationSettingsRaw(): Promise<runtime.ApiResponse<NotificationSettingsData>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/notificationSetting`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * get user notification setting
     */
    async chatControllerNotificationSettings(): Promise<NotificationSettingsData> {
        const response = await this.chatControllerNotificationSettingsRaw();
        return await response.value();
    }

    /**
     */
    async chatControllerSendMessageRaw(requestParameters: ChatControllerSendMessageRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sendChatMessage === null || requestParameters.sendChatMessage === undefined) {
            throw new runtime.RequiredError('sendChatMessage','Required parameter requestParameters.sendChatMessage was null or undefined when calling chatControllerSendMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/message`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendChatMessage,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async chatControllerSendMessage(requestParameters: ChatControllerSendMessageRequest): Promise<void> {
        await this.chatControllerSendMessageRaw(requestParameters);
    }

    /**
     * notification settings
     */
    async chatControllerSetNotificationRaw(requestParameters: ChatControllerSetNotificationRequest): Promise<runtime.ApiResponse<NotificationSettingsData>> {
        if (requestParameters.notificationSettingParam === null || requestParameters.notificationSettingParam === undefined) {
            throw new runtime.RequiredError('notificationSettingParam','Required parameter requestParameters.notificationSettingParam was null or undefined when calling chatControllerSetNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.notificationSettingParam,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * notification settings
     */
    async chatControllerSetNotification(requestParameters: ChatControllerSetNotificationRequest): Promise<NotificationSettingsData> {
        const response = await this.chatControllerSetNotificationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Verbose my own user info
     */
    async echoControllerMeRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Verbose my own user info
     */
    async echoControllerMe(): Promise<void> {
        await this.echoControllerMeRaw();
    }

    /**
     */
    async shopifyWebhookControllerHandleCustomerDeletionRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/_webhooks/shopify/customer_deletion`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyWebhookControllerHandleCustomerDeletion(): Promise<void> {
        await this.shopifyWebhookControllerHandleCustomerDeletionRaw();
    }

}
